import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiError } from "@plotlounge/shared/api";
import { getApiClient } from "./api-client";
import type { Facilitator } from "./staff/facilitator-types";

const KEY = ["me", "facilitator-invitation"] as const;

export function useMyFacilitatorInvitationQuery() {
  return useQuery<Facilitator | null>({
    queryKey: KEY,
    queryFn: async () => {
      try {
        return await getApiClient().get<Facilitator>("/facilitator/invitation");
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) {
          return null;
        }
        throw err;
      }
    },
    staleTime: 30 * 1000,
    retry: false,
  });
}

export function useAcceptFacilitatorInviteMutation() {
  const qc = useQueryClient();
  return useMutation<Facilitator, Error, void>({
    mutationFn: () =>
      getApiClient().post<Facilitator>("/facilitator/invitation/accept", {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function useDeclineFacilitatorInviteMutation() {
  const qc = useQueryClient();
  return useMutation<Facilitator, Error, void>({
    mutationFn: () =>
      getApiClient().post<Facilitator>("/facilitator/invitation/decline", {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}
